import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiQComp } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiQCompDialogData {
  comps?: ApiQComp[];
}

@Component({
  selector: 'app-multi-qcomp-dialog',
  templateUrl: './multi-qcomp-dialog.component.html',
  styleUrls: ['./multi-qcomp-dialog.component.css'],
  standalone: false,
})
export class MultiQcompDialogComponent implements OnInit {

  //FAQ×言語数
  comps: ApiQComp[] = [];
  compsFormGroup!: FormGroup;
  compsArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiQcompDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiQCompDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.comps = this.data.comps!;
    if (!this.comps) {
      this.comps = [];
    }
    this.createForm();
    this.compsArrayControl = this.compsFormGroup.get('comps') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.compsFormGroup.disable();
    }
  }

  //FAQフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.comps.length ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let comp = '';
      let trans_comp = '';
      for (const value of this.comps) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          comp = value.comp;
          trans_comp = value.trans_comp;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          comp: [comp],
          transComp: [trans_comp],
        }
      ));
      index++;
    }
    this.compsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        comps: arrayControl
      }
    );
  }

  //更新ボタン
  addComps(): void {
    if (this.compsFormGroup.valid) {
      let comps = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.compsArrayControl.controls[index];
        comps.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            comp: ctrl.get('comp')!.value,
            trans_comp: ctrl.get('transComp')!.value,
          }
        )
      }
      this.comps = comps;
      this.dialogRef.close(this.comps);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.compsFormGroup.get('autoAllTrans')!.value;
    for (const comp of this.compsArrayControl.controls) {
      comp.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.compsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const comp of this.compsArrayControl.controls) {
      if (!comp.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.compsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
